import Loader from "components/shared/loader";
import { featureModuleTypesEnum, organizationFlagsEnum } from "helpers/enums";
import React, { useEffect, useState } from "react";
import { getItem as getCloseBidDriver } from "sources/books/drivers";
import { getItem as getCloseBidTrailer } from "sources/books/trailers";
import { getItem as getCloseBidTruck } from "sources/books/trucks";
import Driver from "./driver";
import Trailer from "./trailer";
import Truck from "./truck";

const FormBooks = (props) => {
    const {
        coupling,
        profile,
        driver,
        carOption,
        trailerOption,
        onChange,
        modal,
        enums,
        bookFieldsLoading,
        baseConfig,
        renderCheckbox,
        carStatus,
        trailerStatus,
        action,
        updateCarAvailability,
        updateTrailerAvailability,
        firstPoint,
        secondaryDriver,
        roles,
        refuelingSettings,
        organization,
        isEmptyMileageBid,
    } = props;
    const [showSecondaryDriver, setShowSecondaryDriver] = useState(
        profile.availableFeatureModules.includes(featureModuleTypesEnum.PairedCrew) && !!secondaryDriver?.id,
    );

    useEffect(() => {
        if (secondaryDriver?.id) {
            setShowSecondaryDriver(true);
        }
    }, [secondaryDriver?.id]);

    const tripCouplingEnabled =
        profile.availableFeatureModules.includes(featureModuleTypesEnum.TripCoupling) &&
        !organization?.flags?.includes(organizationFlagsEnum.UseTrailerMileage);
    const getBookItemValue = (defaultValue) => {
        if (!tripCouplingEnabled) {
            return defaultValue;
        }
        return coupling ? coupling.id : null;
    };
    return (
        <div className="position-relative">
            {bookFieldsLoading && (
                <div className="loader-snippet--disable-loader">
                    <Loader />
                </div>
            )}
            <div className="form-group">
                <strong>Доставка</strong>
            </div>
            <Driver
                modal={modal}
                roles={roles}
                profile={profile}
                organization={organization}
                onChange={onChange}
                value={getBookItemValue(driver ? driver.id : null)}
                item={driver || {}}
                enums={enums}
                getItem={getCloseBidDriver}
                tripCouplingEnabled={tripCouplingEnabled}
                action={action}
                firstPoint={firstPoint}
                renderCheckbox={renderCheckbox}
                driverForwarderConfig={baseConfig.isDriverForwarder}
                setShowSecondaryDriver={setShowSecondaryDriver}
                showToggleSecondaryDriverBtn={
                    profile.availableFeatureModules.includes(featureModuleTypesEnum.PairedCrew) && !showSecondaryDriver
                }
            />
            {showSecondaryDriver && (
                <Driver
                    isSecondaryDriver
                    modal={modal}
                    roles={roles}
                    profile={profile}
                    organization={organization}
                    onChange={onChange}
                    value={secondaryDriver?.id}
                    item={secondaryDriver || {}}
                    enums={enums}
                    getItem={getCloseBidDriver}
                    action={action}
                    firstPoint={firstPoint}
                    setShowSecondaryDriver={setShowSecondaryDriver}
                    showToggleSecondaryDriverBtn={
                        profile.availableFeatureModules.includes(featureModuleTypesEnum.PairedCrew) &&
                        showSecondaryDriver
                    }
                />
            )}
            <Truck
                modal={modal}
                roles={roles}
                profile={profile}
                refuelingSettings={refuelingSettings}
                organization={organization}
                onChange={onChange}
                value={getBookItemValue(carOption ? carOption.carId : null)}
                idKey="carId"
                item={carOption || {}}
                carStatus={carStatus}
                updateCarAvailability={updateCarAvailability}
                enums={enums}
                getItem={getCloseBidTruck}
                tripCouplingEnabled={tripCouplingEnabled}
                action={action}
                firstPoint={firstPoint}
            />
            {baseConfig.trailerOption && !baseConfig.trailerOption.isHidden && (
                <Trailer
                    modal={modal}
                    roles={roles}
                    profile={profile}
                    refuelingSettings={refuelingSettings}
                    organization={organization}
                    onChange={onChange}
                    value={getBookItemValue(trailerOption ? trailerOption.trailerId : null)}
                    idKey="trailerId"
                    item={trailerOption || {}}
                    enums={enums}
                    getItem={getCloseBidTrailer}
                    baseConfig={baseConfig.trailerOption}
                    tripCouplingEnabled={tripCouplingEnabled}
                    action={action}
                    firstPoint={firstPoint}
                    trailerStatus={trailerStatus}
                    updateTrailerAvailability={updateTrailerAvailability}
                    isEmptyMileageBid={isEmptyMileageBid}
                />
            )}
        </div>
    );
};

export default FormBooks;
